import { Card } from '@sainsburys-tech/luna-card'
import {
  Title,
  ReferenceNumber,
  Investigation,
  IncidentDescription,
  ReportedByDescription
} from '../Components'
import { IIncident } from '../../../types'
import PromptComponent from '../../Reporting/ComponentSwitch/Components/PromptComponent'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useApiClient } from '../../../context/AppContext'
import getFeatureData from '../../../utils/getFeatureData'
import useCurrentStore from '../../../hooks/useCurrentStore'

const IncidentCard = ({ incident }: IIncident) => {
  const apiClient = useApiClient()
  const storeCode = useCurrentStore().storeCode
  
  const [showPrompt, setShowPrompt] = useState(false)
  const [DIFeature, setDIFeature] = useState<boolean>()

  getFeatureData(apiClient, 'DigitalInvestigations', storeCode).then(response => setDIFeature(response))
  const navigateTo = useNavigate()

  function createInvestigation() {
    if (sessionStorage.getItem('draftId')) {
      sessionStorage.removeItem('draftId')
    }
    if (sessionStorage.getItem('investigationId')) {
      sessionStorage.removeItem('investigationId')
    }
    if (sessionStorage.getItem('enforcementContact') == 'true') {
      sessionStorage.setItem('enforcementContact', 'false')
    }
    sessionStorage.setItem('investigationId', incident.recordId.toString())
    navigateTo('/reporting')
  }

  function handlePromptResponse(response: boolean) {
    setShowPrompt(false)
    if (response) {
      createInvestigation()
    }
  }

  return (
    <>
      {showPrompt ? (
        <PromptComponent
          title={'Start an investigation'}
          body={'Do you want to start an investigation on this incident?'}
          text={'Start an investigation'}
          icon={'BlueInfoIcon'}
          classification=''
          handleResult={handlePromptResponse}
        />
      ) : null}
      <div className={incident.status === 'Investigation Required' ? 's-card-clickable' : ''} >
        <Card
          className="s-reported-accident-card rln-c-card ln-c-card--soft ln-u-margin-bottom*2 ln-u-margin-left"
          onClick={() => DIFeature && incident.status === 'Investigation Required' && setShowPrompt(true)}
        >
          <Title text={incident.category} />
          <ReferenceNumber referenceNumber={incident.reference} />
          <Investigation status={incident.status} />
          <IncidentDescription
            dateOfIncident={incident.dateOfIncident}
            timeOfIncident={incident.timeOfIncident}
            location={incident.location}
            store={incident.store}
            type={'incident'}
          />
          <ReportedByDescription
            reportedBy={incident.reportedBy}
            dateReported={incident.dateReported}
            timeReported={incident.timeReported}
          />
        </Card>
    </div>
    </>
  )
}

export default IncidentCard
